import React from 'react';
import { SlideOutButton } from 'resources/js/personas/byron/header/SlideOutButton';
import VerticalMenu from 'resources/js/personas/shared/components/Menu/VerticalMenu';
import { useStyles, StyleSheet } from '@rexlabs/styling';
import { HeaderMenu } from 'resources/js/personas/byron/header/HeaderBlock';
import HamburgerMenuIcon from './icons/v2HamburgerMenu.svg';

const hamburgerMenuDefaultStyles = StyleSheet({
  desktopHamburgerMenu: {
    display: 'none',
    flex: 1,
    boxSizing: 'border-box',
    width: '72px',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',

    '@media(max-width: 1024px)': {
      display: 'flex'
    }
  }
});

interface Props {
  menuBackgroundColor: string;
  transparentFontColor: string;
  menuFontColor: string;
  menuFontHoverColor: string;
  menu: HeaderMenu;
  isTransparent: boolean;
  navMenuOverflowing: boolean;
}

export function HamburgerMenu(props: Props) {
  const {
    menuBackgroundColor,
    transparentFontColor,
    menuFontColor,
    menuFontHoverColor,
    menu,
    isTransparent,
    navMenuOverflowing
  } = props;
  const s = useStyles(hamburgerMenuDefaultStyles);
  return (
    <div
      {...s.with('desktopHamburgerMenu')(
        navMenuOverflowing
          ? {
              display: 'flex'
            }
          : {}
      )}
    >
      <SlideOutButton
        Icon={HamburgerMenuIcon}
        paneDirection={'right'}
        backgroundColor={menuBackgroundColor}
        headerBackgroundColor={menuBackgroundColor}
        hamburgerColor={isTransparent ? transparentFontColor : menuFontColor}
        content={
          <VerticalMenu
            menuFontColor={menuFontColor}
            menuFontHoverColor={menuFontHoverColor}
            menu={menu}
            menuBackgroundColor={menuBackgroundColor}
          />
        }
      />
    </div>
  );
}
